import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Humberg from '../../../elements/Humberg';
import Loader from '../../loader/loader';
import { CREATE_ORDER_RESET } from '../../../redux/constants/orderConstants';
import { clearErrors } from '../../../redux/actions/userActions';
import { OrderDetailsAction } from '../../../redux/actions/orderActions';
import RemarksForm from './RemarksOnOrderForm';


const RemarksOnOrder = () => {


    const dispatch = useDispatch()
    const navigate = useNavigate()


    const { loading, order } = useSelector(state => state.orders)
    const { loading: createOrderLoading, error, message } = useSelector(state => state.order)




    const [searchParams] = useSearchParams()
    const order_id = searchParams.get("order_id");


    const [showPopup, setShowPopup] = useState(false);




    useEffect(() => {



        const Headerlinkks = document.querySelectorAll(".headerLinks");
        const subLinks = document.querySelectorAll(".subLinks");
        const element = document.getElementById("orders")


        Headerlinkks.forEach(el => el.classList.remove("activeHeaderLink"));
        subLinks.forEach(el => el.classList.remove("activeSubLink"));
        element?.classList.add("activeHeaderLink");

        document.title = `Review The Order `;




    }, []);

    // Remove one quantity




    useEffect(() => {


        if (error) {
            setShowPopup(true)
        }

        if (message) {
            dispatch({ type: CREATE_ORDER_RESET })
            navigate("/orders/all-orders")
        }

    }, [error, message, dispatch, navigate])



    const handleClosePopup = () => {
        setShowPopup(false)
        dispatch(clearErrors())
    }




    useEffect(() => {

        if (order_id) {
            dispatch(OrderDetailsAction(order_id))
        }

    }, [order_id, dispatch])



    useEffect(() => {

        console.log(order?.status)

    }, [order])



    return (
        <Fragment>
            {(loading || createOrderLoading) && <Loader />}
            <Humberg header="Orders" headerLink="/orders/all-orders" children={"Remarks"} />
            <section className="p-[1.5vmax] pt-[0.5vmax]">
                {(!order || (order?.status === "CANCELLED" || order?.status === "SYSTEM_CANCELLED" || order?.status === "SUSPENDED")) ?
                    <div className="bg-white p-[4vmax_2vmax] shadow-1 rounded-xl ">
                        <h2 className="text-[1.8vmax]  pb-[0.2vmax]  font-3 font-[800] mx-auto w-fit mb-[1vmax] text-red-500" > Can't Report The Order</h2>
                        <p className='w-[60%] mx-auto text-center text-[1.2vmax]' >
                            Sorry, but you cannot report this order as it is either cancelled, system deleted, or suspended. If you believe this is an error, please contact support for further assistance.
                        </p>
                        <div className="flex-center mt-[1vmax]">

                            <Link to={'/orders/all-orders'} className="mx-auto text-white bg-[image:var(--gradient-2)] p-[0.7vmax_1.5vmax] rounded-[2vmax]">
                                Go Back
                            </Link>

                        </div>
                    </div>
                    :
                    <div className="bg-white p-[2vmax] shadow-1 rounded-xl">
                        <div className="flex justify-between">
                            <RemarksForm order={order} />
                        </div>
                    </div>
                }
            </section>
            {showPopup &&
                <section className="w-[100%] min-h-[100vh] flex-center fixed top-0 left-0 bg-[#000000b7] z-[99999999999]">
                    <button className="fixed top-[2vmax] right-[2vmax]"
                        onClick={() => setShowPopup(false)}
                    >
                        <i className="fa-solid fa-xmark text-white text-[2vmax]"></i>
                    </button>
                    <div className="bg-white rounded-xl  shadow-1 overflow-hidden w-[80%] lg:w-[35%]">
                        <div className="font-3 font-[700] text-white bg-[image:var(--gradient-4)] py-[0.6vmax] text-center text-[2vmax] lg:text-[1.5vmax]">
                            Report Order Issue
                        </div>
                        <p className='p-[1.5vmax] text-[1.5vmax] lg:text-[1.1vmax] text-slate-700' >
                            {error}
                        </p>
                        <div className="flex justify-end gap-[1.5vmax] p-[1.5vmax]">

                            <button className="text-[1.5vmax] lg:text-[1.1vmax] font-3 bg-[image:var(--gradient-3)] text-white 
                            p-[0.5vmax_1vmax] rounded-lg"
                                onClick={() => handleClosePopup()}
                            >Ok</button>
                        </div>
                    </div>
                </section>

            }
        </Fragment>
    )
}

export default RemarksOnOrder